import styled from "styled-components";

export default styled.div`
  .key {
    color: #89cdff;
  }
  .value {
    color: #fff;
  }
  .commission-rate-component {
    background: linear-gradient(279deg, #142977, #2145d4) !important;
    background-position: 100px;
    position: relative;
    border-radius: 18px;
    min-height: 85px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-inline-start: 2rem;
    > div {
      width: 100%;
      max-width: 200px;
    }
    img {
      position: absolute;
      right: 30px;
      top: -37px;
      width: 100px;
      height: 100px;
      user-select: none;
    }
  }
  .affiliates-component {
    min-height: 96px;
    justify-content: center;
    border-radius: 18px;
    hr {
      margin: 0.5rem 0rem;
    }
  }
  .card-custom {
    border-radius: 18px;
  }
  .btn-primary-custom {
    border-radius: 8px;
  }
  .my-commission-card-component {
    background: linear-gradient(279deg, #142977, #2145d4) !important;
    background-position: 100px;
    position: relative;
    border-radius: 18px;
    min-height: 95px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-inline-start: 2rem;
    margin-top: 1rem;
    > div {
      width: 100%;
      max-width: 200px;
    }
    img {
      position: absolute;
      right: 40px;
      width: fit-content;
      height: 80px;
      user-select: none;
      max-width: 70px;
    }
  }
  .margin-top-10px {
    margin-top: 10px;
  }

  @media screen and (max-width: 767px) {
    .col-md-7 {
      order: 2;
      margin-top: 1rem;
    }
    .row {
      margin-top: 1rem;
    }
  }
  @media screen and (max-width: 768px) {
    .container {
      padding: 0;
    }
    .margin-top-10px {
      margin-top: 0px;
    }
  }
`;
